<template>
    <div id="all-chat">
        <div style="background-color: #ffffff" class="d-flex w-100">
            <div class="content">
                <div class="all-chat-container">
                    <div class="header">
                        <FilterTool v-model="filters" :isGraphShowing="true" :keep-state-on-query-params="true" />
                    </div>
                    <div
                        v-if="loading"
                        class="h-50 d-flex flex-column justify-content-center align-items-center text-align-center"
                    >
                        <a-spin />
                        <p>{{ $t("message.loading") }}</p>
                    </div>
                    <LineGraphic
                        :key="`${renderKey}`"
                        v-if="graphData.length"
                        :graphData="graphData"
                        :total-data="totalData"
                        :avg-data="avgData"
                        :timeSeriesType="timeSeriesType"
                        sub-title="allChats"
                    />
                    <div class="d-flex justify-content-center mt-5" v-else>
                        <ChartNotFound :title="$t('message.dataNotFound')" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SideMenuBar from "../../SideMenuBar";
import LineGraphic from "../../components/LineGraphic";
import FilterTool from "../archive/FilterTool";
import ChartNotFound from "../../components/ChartNotFound";
import { IS_CHARTS_PUBLIC } from "../../chatbot";
import { mapMutations, mapState, mapActions, mapGetters } from "vuex";
import ComingSoonWrapper from "./ComingSoonWrapper";
import { log2 } from "../../../../../utils/log2";
import _ from "lodash";
import moment from "moment";
import { CHATBOT_API } from "../../../../../api/chatbotv2";
import { PERMISSION_TYPES } from "../../../../../language/permissionTypes";
import ChatbotMenu from "../../ChatbotMenu.vue";

const log = log2("AllChats");

export default {
    name: "AllChats",
    components: {
        ChatbotMenu,
        ChartNotFound,
        FilterTool,
        LineGraphic,
        SideMenuBar,
        ComingSoonWrapper,
    },
    data() {
        return {
            IS_CHARTS_PUBLIC,
            renderKey: 0,
            graphData: [],
            totalData: { message: this.$t("chatbotv2.totalData"), value: 0 },
            avgData: { message: this.$t("chatbotv2.avgData"), value: 0 },
            story: null,
            datePeriod: 30,
            timeSeriesType: "daily",
            loading: true,

            filters: {
                period: this.$route.query.period || "today",
                integration: this.$route.query.integration || null,
                storyId: this.$route.query.storyId || null,
                startDate: this.$route.query.startDate || moment().startOf("day").toISOString(),
                endDate: this.$route.query.endDate || moment().endOf("day").toISOString(),
            },
        };
    },
    methods: {
        ...mapActions({
            listStories: "CB/listStories",
        }),
        getBuckets(result) {
            if (!result.length) return null;
            else {
                const date = new Date();
                if (!this.filters.period) {
                    this.filters.period = "today";
                }
                return _.range(0, this.datePeriod).map((i) => {
                    if (this.timeSeriesType === "monthly") {
                        if (this.filters.period === "last-year") {
                            const lastYear = date.getFullYear() - 1;
                            let lastYearDate = new Date(lastYear, 0, 1);
                            date.setMonth(lastYearDate.getMonth() - (i + 1));
                            return {
                                date: date.toISOString().slice(0, 7),
                                value: 0,
                            };
                        } else {
                            date.setMonth(date.getMonth() - i);
                            return {
                                date: date.toISOString().split("T")[0].slice(0, 7),
                                value: 0,
                            };
                        }
                    } else if (this.timeSeriesType === "daily") {
                        if (this.filters.period === "last-month") {
                            const dateOfLastDayOfPreviousMonth = new Date(date.getFullYear(), date.getMonth(), 0);
                            dateOfLastDayOfPreviousMonth.setDate(dateOfLastDayOfPreviousMonth.getDate() - (i - 1));
                            return {
                                date: dateOfLastDayOfPreviousMonth.toISOString().split("T")[0],
                                value: 0,
                            };
                        } else {
                            date.setDate(date.getDate() - i);
                            return {
                                date: date.toISOString().split("T")[0],
                                value: 0,
                            };
                        }
                    } else if (this.timeSeriesType === "hourly") {
                        if (this.filters.period === "yesterday") {
                            const lastHourOfPreviousDay = new Date(
                                date.getFullYear(),
                                date.getMonth(),
                                date.getDate(),
                                -1
                            );
                            lastHourOfPreviousDay.setHours(lastHourOfPreviousDay.getHours() + 3 - i);
                            return {
                                date: lastHourOfPreviousDay.toISOString().slice(0, 13),
                                value: 0,
                            };
                        } else if (this.filters.period === "today") {
                            date.setHours(moment().hour() + 3 - i);
                            return {
                                date: date.toISOString().slice(0, 13),
                                value: 0,
                            };
                        }
                    }
                });
            }
        },

        fetchConversations() {
            this.loading = true;
            if (this.filters.period !== "custom") {
                this.filters.startDate = null;
                this.filters.endDate = null;
                this.$router.replace({
                    query: {
                        period: this.filters.period,
                        integration: this.filters.integration,
                        storyId: this.filters.storyId,
                    },
                });
            }
            CHATBOT_API.REPORT.timeSeries({ ...this.filters, timeSeriesType: this.timeSeriesType })
                .then(async (res) => {
                    const { result } = res.data;
                    log("results", result);
                    const buckets = this.getBuckets(result);
                    log("buckets", buckets);
                    if (!!buckets) {
                        if (this.timeSeriesType === "hourly")
                            this.graphData = buckets.reduce((acc, curr) => {
                                let obj = {};
                                obj["value"] = !!result.find((x) => {
                                    return (
                                        curr.date ===
                                        `${x.date.slice(0, 13).split("T")[0]}T${
                                            parseInt(x.date.slice(0, 13).slice(-2)) + 3
                                        }`
                                    );
                                })
                                    ? result.find(
                                          (x) =>
                                              `${x.date.slice(0, 13).split("T")[0]}T${
                                                  parseInt(x.date.slice(0, 13).slice(-2)) + 3
                                              }` === curr.date
                                      ).value
                                    : 0;
                                obj["date"] = curr.date.split("T")[0] + " " + curr.date.split("T")[1] + ":00";
                                acc.push(obj);
                                return acc;
                            }, []);
                        else if (this.timeSeriesType === "monthly")
                            this.graphData = buckets.reduce((acc, curr) => {
                                let obj = {};
                                obj["value"] = !!result.find((x) => x.date.split("T")[0].slice(0, 7) === curr.date)
                                    ? result.find((x) => x.date.split("T")[0].slice(0, 7) === curr.date).value
                                    : 0;
                                obj["date"] = curr.date;
                                acc.push(obj);
                                return acc;
                            }, []);
                        else
                            this.graphData = buckets.reduce((acc, curr) => {
                                let obj = {};
                                obj["value"] = !!result.find((x) => x.date.split("T")[0] === curr.date)
                                    ? result.find((x) => x.date.split("T")[0] === curr.date).value
                                    : 0;
                                obj["date"] = curr.date;
                                acc.push(obj);
                                return acc;
                            }, []);

                        if (!!this.totalData && !!this.graphData) {
                            this.totalData["value"] = result.reduce((acc, curr) => {
                                acc += parseInt(curr.value);
                                return acc;
                            }, 0);
                            log("this.totalData ", this.totalData["value"]);
                            this.avgData["value"] = Math.floor(_.get(this.totalData, "value") / this.graphData.length);
                            log("this.avgData ", this.totalData["value"]);
                        }
                    } else {
                        this.graphData = [];
                    }
                    this.renderKey += 1;
                    log("this.graph", this.graphData);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    computed: {
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
        ...mapState({
            stories: (state) => state.CB.stories,
        }),
    },
    mounted() {
        this.listStories();
        this.fetchConversations();
    },
    beforeMount() {
        if (this.checkPermission(PERMISSION_TYPES["chatbot.reports.view"].tr.name) === false) {
            return router.push("/denied");
        }
    },
    watch: {
        filters: {
            handler(newVal) {
                if (!!newVal) {
                    log("filters changed", this.filters);
                    const date = new Date();
                    if (newVal.period === "today" || newVal.period === "yesterday") {
                        this.timeSeriesType = "hourly";
                        if (newVal.period === "today") this.datePeriod = moment().hour() + 1;
                        if (newVal.period === "yesterday") this.datePeriod = 24;
                    } else if (
                        newVal.period === "last-3-month" ||
                        newVal.period === "this-year" ||
                        newVal.period === "last-year"
                    ) {
                        this.timeSeriesType = "monthly";
                        if (newVal.period === "last-3-month") this.datePeriod = 3;
                        if (newVal.period === "this-year") this.datePeriod = date.getMonth() + 1;
                        if (newVal.period === "last-year") this.datePeriod = 12;
                    } else {
                        this.timeSeriesType = "daily";
                        if (newVal.period === "last7") this.datePeriod = 7;
                        else if (newVal.period === "last30") this.datePeriod = 30;
                        else if (newVal.period === "this-month") this.datePeriod = date.getDate();
                        else if (newVal.period === "last-month")
                            this.datePeriod = new Date(date.getFullYear(), date.getMonth(), 0).getDate();
                    }
                    this.fetchConversations();
                }
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss">
#all-chat {
    width: 100%;
    height: auto;
    min-height: 100vh;
    display: flex;

    .side-menubar-wrapper {
        min-height: 100vh;
        flex: 0 0 15%;
        height: 100%;
    }

    .content {
        padding: 10px;
        display: flex;
        flex-direction: column;
        position: relative;
        background: white;
        width: 100%;
        height: 100%;
        min-height: 100vh;

        .all-chat-container {
            width: 100%;

            .header {
                width: 100%;
            }

            .chart {
                max-width: 1050px;
            }
        }
    }
}
</style>
